import libphonenumber, { PhoneNumberFormat } from 'google-libphonenumber';

function getFormattedInternationalPhoneNumber(number: string) {
    const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
    const phoneNumber = phoneUtil.parse(number, undefined);
    return phoneUtil.format(phoneNumber, PhoneNumberFormat.INTERNATIONAL);
}

export default getFormattedInternationalPhoneNumber;
